export const partnerType = {
  PJ: "PJ",
  PF: "PF",
  PFA: "PFA"
};
